import { CgArrowRight } from 'react-icons/cg';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';

import { ButtonWrapper } from './styles';
import { ButtonSpaceG } from '../../sharedStyles';

export const ButtonContainer = (props: {
  onClickForward: any;
  onClickCancel?: any;
  disabled?: boolean;
}): JSX.Element => {
  const { onClickForward, onClickCancel, disabled } = props;

  const stateClaim = useSelector((state: ApplicationState) => state.openClaim);

  return (
    <ButtonWrapper>
      <ButtonSpaceG size="small" type="button" onClick={() => onClickCancel()}>
        {stateClaim.draftId && stateClaim.currentStep !== 1
          ? 'Salvar e Sair'
          : 'Sair'}
      </ButtonSpaceG>
      <ButtonSpaceG
        size="small"
        type="button"
        onClick={onClickForward}
        styleSemantic="success"
        disabled={disabled}
      >
        {stateClaim.currentStep === 5 ? 'Enviar Sinistro' : 'Avançar'}
        <CgArrowRight size={17} className={disabled ? 'disabled' : ''} />
      </ButtonSpaceG>
    </ButtonWrapper>
  );
};
